export default __webpack_public_path__ + "static/media/Ayuda.b48e7f85.png";